import React from "react";
import Button from "../Button";

const FormLayout: React.FC<{
  children: React.ReactNode;
  formAction: any;
  isPending: boolean;
  submitLabel: string;
  backLabel?: string;
  onBack?: () => void;
}> = ({ children, formAction, isPending, submitLabel, onBack, backLabel }) => {
  return (
    <form noValidate action={formAction} className="flex flex-col gap-4 w-full">
      <div className="grid grid-cols-6 w-full gap-2">{children}</div>
      <div className="flex col-span-6 justify-end gap-2">
        {backLabel && onBack && (
          <Button onClick={() => onBack && onBack()}>{backLabel}</Button>
        )}
        <Button
          className=" bg-[var(--form-button-bg-color)] text-[var(--form-button-text-color)] hover:bg-[var(--form-button-hover-bg-color)] hover:text-[var(--form-button-hover-text-color)] "
          loading={isPending}
          type="submit"
        >
          {submitLabel}
        </Button>
      </div>
    </form>
  );
};

export default FormLayout;
